import React, { useEffect, useRef, useState } from 'react';
import { formatarDataBr, validarData, validarSaidaDate } from '../../../../ultis/validate';
import { useDispatch, useSelector } from 'react-redux';
import { postSaidaProduto, reset as resetSaida } from '../../../../slices/saidaProductSlice';
import Main from '../../../../components/Main/Main';
import Title from '../../../../components/Title';
import Form from '../../../../components/Main/Form';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import { Trash2 } from 'lucide-react';
import { useForm } from 'react-hook-form';
import InputGlobal from '../../../../components/InputGlobal';
import Adicionar from '../../../../components/Buttons/Adicionar';
import ButtonGlobal from '../../../../components/ButtonGlobal';
import { products } from '../../../../slices/productSlice';
import { Typography } from '@material-tailwind/react';
import ProdutoCod from '../../../../components/autoComplet/ProdutoCod';
import MsgInputError from '../../../../components/MsgInputError';
import MsgSucess from '../../../../components/MsgSucess';
import LinhaDeSaida from '../../../../components/autoComplet/LinhasDeSaida';
import usePageTitle from '../../../../hook/usePageTitle';

const Saidas = () => {
  usePageTitle();

  const dispatch = useDispatch();
  const [listOut, setListOut] = useState([]);
  const { loading, success } = useSelector((state) => state.saidaProduct);
  const [post, setPost] = useState(false);
  const [winthor, setWinthor] = useState(null);
  const [inputValue, setInputValue] = React.useState('');
  const [formRequired, setFomrRequired] = useState(false);
  const inputRefProduto = useRef(null);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm();
  const linha = watch('linha');

  useEffect(() => {
    clearErrors('linha');
  }, [linha]);

  const cleanCamp = () => {
    setValue('produto', '');
    setValue('quantidade', '');
    setValue('linha', '');
    setValue('equipamento', '');
    setValue('funcionario', '');
    setValue('nome', '');
    setInputValue('');
    setWinthor(null);
  };

  useEffect(() => {
    setValue('produtoWinthor', winthor);
    setFomrRequired(false);
  }, [winthor]);

  const removeItemProduto = (index) => {
    setListOut((prevLista) => {
      const novaLista = [...prevLista]; // Faz uma cópia da lista
      novaLista.splice(index, 1); // Remove o item no índice especificado
      return novaLista; // Retorna a nova lista
    });
  };

  const resetInfo = () => {
    setInputValue('');
    setWinthor(null);
    reset();
    setListOut([]);
    resetSaida();
    setPost(false);
    dispatch(products());
  };

  useEffect(() => {
    return () => resetInfo();
  }, []);

  const addProduct = (data) => {
    if (!winthor) {
      setFomrRequired(true);
      return;
    }
    const { quantidade, linha, equipamento, funcionario, data: date } = data;
    const produto = data.produtoWinthor.winthor;
    const nome = data.produtoWinthor.nome;
    const dados = {
      data: date,
      produto,
      linha: linha.nome,
      quantidade,
      equipamento,
      funcionario,
      nome,
    };
    cleanCamp();
    setListOut((prev) => [dados, ...prev]);
  };

  const onSubmit = () => {
    if (listOut.length > 0) {
      listOut.forEach((item) => {
        dispatch(postSaidaProduto(item));
      });
      setPost(true);
      setValue('data', '');
    }
  };

  const handleProductFocus = () => {
    inputRefProduto.current?.focus();
  };

  const handleEnterPress = (event) => {
    // Adicionar produto quando clicado enter no ultimo campo do formulario
    if (event.key === 'Enter') {
      handleSubmit(addProduct)();
      handleProductFocus();
    }
  };

  return (
    <Main>
      <Title className="formTitulo">Saida de produto</Title>
      <Form>
        <div className="w-[90%] px-2 sm:w-auto">
          <InputGlobal
            formCamp="data"
            type="date"
            label="Data"
            register={register}
            errors={errors?.data ? errors : false}
            required={true}
            validations={{ required: true, validate: validarSaidaDate }}
          />
        </div>
        <div className="w-[90%] flex-col px-2 sm:px-0 sm:w-full lg:w-[80%] ">
          <div className="flex gap-2 w-full flex-wrap">
            <div className="w-full sm:flex gap-2">
              <div className="sm:w-[70%] sm:flex-1 md:flex-none lg:w-[80%]">
                <Typography
                  variant="h6"
                  className="mb-1 text-left font-medium text-black dark:text-white capitalize"
                >
                  Produto *
                </Typography>
                <ProdutoCod
                  register={register}
                  value={winthor}
                  setValue={setWinthor}
                  inputValue={inputValue}
                  setInputValue={setInputValue}
                  inputRef={inputRefProduto}
                />
                {formRequired && <MsgInputError text="Este campo é obrigatório" />}
              </div>
              <div className="w-[100%] sm:flex-1 sm:w-[20%]">
                <InputGlobal
                  formCamp="quantidade"
                  type="number"
                  label="quantidade"
                  placeholder=""
                  register={register}
                  errors={errors?.quantidade ? errors : false}
                  required={true}
                  validations={{ required: true }}
                />
              </div>
            </div>
            <div className="w-[50%] flex-1">
              <InputGlobal
                formCamp="funcionario"
                type="text"
                label="Solicitante"
                placeholder=""
                register={register}
                errors={errors?.funcionario ? errors : false}
                required={true}
                validations={{ required: true }}
                autoComplete="func"
              />
            </div>
            <div className="flex-1">
              <Typography
                variant="h6"
                className="mb-1 text-left font-medium text-black dark:text-white capitalize"
              >
                Linha *
              </Typography>
              <LinhaDeSaida setLinha={setValue} reset={!!linha} />
              <input
                className="hidden"
                {...register('linha', { required: true })}
                type="text"
                value={linha}
              />

              {errors?.linha && <MsgInputError text="Este campo é obrigatório" />}
            </div>
            <div className="flex-1" onKeyDown={handleEnterPress}>
              <InputGlobal
                formCamp="equipamento"
                type="text"
                label="equipamento"
                placeholder="Digite o equipamento"
                register={register}
                errors={errors?.equipamento ? errors : false}
                required={true}
                validations={{ required: true }}
              />
            </div>
          </div>
        </div>
        <div className="flex gap-2 justify-between w-[80%]">
          <Adicionar
            text="Adicionar"
            click={handleSubmit(addProduct)}
            error={Object.keys(errors).length > 0 ? true : false}
          />
          <ButtonGlobal
            text="Salvar"
            click={onSubmit}
            loading={loading}
            disabled={listOut.length === 0}
          />
        </div>
        {post && <MsgSucess reset={resetInfo} outText="Saida de produto salvo com sucesso" />}
      </Form>
      <div className=" w-[90%] h-[99%] overflow-auto mx-auto pb-2">
        <Paper
          sx={{
            width: '100%',
            height: '100%',
            bgcolor: 'transparent',
            overflow: 'auto',
          }}
        >
          <TableContainer sx={{ height: '100%', textTransform: 'uppercase' }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>Data</TableCell>
                  <TableCell>Cod</TableCell>
                  <TableCell>Nome</TableCell>
                  <TableCell>Quantidade</TableCell>
                  <TableCell>Solicitante</TableCell>
                  <TableCell>Linha</TableCell>
                  <TableCell>Equipamento</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listOut.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{formatarDataBr(item.data)}</TableCell>
                    <TableCell>{item.produto}</TableCell>
                    <TableCell>{item.nome}</TableCell>
                    <TableCell>{item.quantidade}</TableCell>
                    <TableCell>{item.funcionario}</TableCell>
                    <TableCell>{item.linha}</TableCell>
                    <TableCell>{item.equipamento}</TableCell>
                    <TableCell align="right">
                      <Tooltip
                        content="Remover"
                        onClick={() => {
                          removeItemProduto(index);
                        }}
                      >
                        <Trash2
                          color="red"
                          className="hover:text-red-500 cursor-pointer ml-auto"
                          onClick={() => {
                            removeItemProduto(index);
                          }}
                        />
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    </Main>
  );
};
export default Saidas;
